import { showSuccessData, showErrorData } from '@/lib/toast'
import { mapUploadImageUrl } from '@/features/editor/lib/editor-media.mapper'

import {
  usePostUploadEngineEngineIdImage,
  usePostUploadEngineEngineIdBackground,
} from '@/types/origin-point-engine'

type UploadKind = 'cover' | 'background'

export function useUploadEngineMedia() {
  const coverMutation = usePostUploadEngineEngineIdImage({
    mutation:{
      onSuccess: () => {
      showSuccessData('封面上传成功')
    },
    onError: () => {
      showErrorData('封面上传失败')
    },
    }
  })
  const bgMutation = usePostUploadEngineEngineIdBackground({
    mutation:{
      onSuccess: () => {
      showSuccessData('背景上传成功')
    },
    onError: () => {
      showErrorData('背景上传失败')
    },
    }
  })

  async function upload(args: {
    engineId: string
    kind: UploadKind
    file: File
  }): Promise<{ url: string }> {
    const { engineId, kind, file } = args

    const res =
      kind === 'cover'
        ? await coverMutation.mutateAsync({
            engineId,
            data: { image: file },
          })
        : await bgMutation.mutateAsync({
            engineId,
            data: { image: file },
          })

    const url = mapUploadImageUrl(res)

    return { url }
  }

  return {
    upload,
    uploadingCover: coverMutation.isPending,
    uploadingBackground: bgMutation.isPending,
  }
}
